/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const lightbulb_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M12 .75v1.5m-10.5 9H3m.75-7.5 1.1 1.057M22.5 11.25H21m-.75-7.5-1.1 1.057M10.5 21h3m-2 2.25h1m6.25-12a6.75 6.75 0 1 0-9.072 6.34c.19.07.322.247.322.449 0 .255.207.461.461.461h3.078a.461.461 0 0 0 .461-.461c0-.202.132-.38.322-.45a6.753 6.753 0 0 0 4.428-6.339Z"
    />
  </svg>
)
export default lightbulb_medium
